import { type ReactNode } from 'react';
import { checkIsAdminOrAiOperator } from '../lib/admin';
import CheckedRoute from './checked-route';

/** Admin pages readable by the `ai_operator` role (conversations, llm usage,
 *  safeguarding, curriculum, prompts) — admin keeps full access, ai_operator
 *  is read-only (mutation UI hidden page-side via `checkIsAdmin()`). */
export default function AdminOrAiOperatorRoute({ children }: { children: ReactNode }) {
  return <CheckedRoute checkFn={checkIsAdminOrAiOperator}>{children}</CheckedRoute>;
}
